import alt from "../alt";
import indexBy from "lodash/keyBy";
import values from "lodash/values";
import ReportScheduleUtil from "../utils/ReportScheduleUtil";
import ReportScheduleActions from "../actions/ReportScheduleActions";
import UserStore from "../stores/UserStore";

class ReportScheduleStore {
  constructor() {
    this.bindActions(ReportScheduleActions);

    this.state = {
      isFetching: false,
      reportSchedules: {}
    };

    this.exportPublicMethods({
      getReportScheduleById: this.getReportScheduleById.bind(this),
      getAllUserReportSchedules: this.getAllUserReportSchedules.bind(this)
    });
  }

  getReportScheduleById(id) {
    return this.state.reportSchedules[id];
  }

  getAllUserReportSchedules() {
    let reportSchedulesArray = [];
    let reportSchedulesList = Object.keys(this.state.reportSchedules);
    for (let rs = 0; rs < reportSchedulesList.length; rs++) {
      reportSchedulesArray = reportSchedulesArray.concat([
        this.state.reportSchedules[reportSchedulesList[rs]]
      ]);
    }
    return reportSchedulesArray;
  }

  onFetchAllForUser() {
    this.setState({ isFetching: true });
    ReportScheduleUtil.fetchAllForUser(UserStore.getState().apiKey)
      .then(data => {
        const reportSchedules = data.reduce((result, item) => {
          result[item.id] = item;
          return result;
        }, {});
        this.setState({ isFetching: false, reportSchedules: reportSchedules });
      })
      .catch(ReportScheduleActions.fetchFailed);
  }

  onFetchOne(id) {
    this.setState({ isFetching: true });
    ReportScheduleUtil.fetchOne(UserStore.getState().apiKey, id)
      .then(data => {
        let reportSchedules = this.state.reportSchedules;
        reportSchedules[data.id] = data;
        this.setState({ isFetching: false, reportSchdules: reportSchedules });
      })
      .catch(ReportScheduleActions.fetchFailed);
  }

  onDelete(id) {
    this.setState({ isDeleting: true });
    ReportScheduleUtil.delete(UserStore.getState().apiKey, id)
      .then(data => {
        ReportScheduleActions.fetchAllForUser();
      })
      .catch(ReportScheduleActions.editFailed);
  }

  onCreate(newData) {
    this.setState({ isCreating: true, newScheduleId: null });

    ReportScheduleUtil.create(UserStore.getState().apiKey, newData)
      .then(data => {
        let reportSchedules = this.state.reportSchedules;
        reportSchedules[data.id] = data;
        this.setState({
          isCreating: false,
          reportSchedules: reportSchedules,
          newScheduleId: data.id
        });
      })
      .catch(ReportScheduleActions.editFailed);
  }

  onUpdate(newData) {
    this.setState({ isUpdating: true });
    ReportScheduleUtil.edit(UserStore.getState().apiKey, newData.id, newData)
      .then(data => {
        let reportSchedules = this.state.reportSchedules;
        reportSchedules[data.id] = data;
        this.setState({ isUpdating: false, reportSchedules: reportSchedules });
      })
      .catch(ReportScheduleActions.editFailed);
  }

  onFetchFailed(e) {
    alert(`Fetching report schedules failed: ${e.message}`);
    throw e;
  }

  onEditFailed(e) {
    alert(`Edit failed: ${e.message}`);
    this.setState({ isCreating: false, isEditing: false });
  }
}

export default alt.createStore(ReportScheduleStore, "ReportScheduleStore");



// WEBPACK FOOTER //
// ./src/app/stores/ReportScheduleStore.js